export { default } from './ResourcesInternalOverview';
